import React from "react";
import Navbar from "../components/Navbar";

import Footer from "../components/Footer";
import ImageCarousel from "../components/Carousel";
import ProjectCard from "../components/ProjectCard";
import ProjectDesciption from "../components/ProjectDescription";

const Project1 = () => {
    const carouselImages = [
        {
          src: "./Semester_6/Umgebung Kopie.webp",
          alt: "Model",
          text: "Urban context in large scale model"
        },
        {
          src: "./Semester_6/Situationsplan.webp",
          alt: "Roof View",
          text: "Urban Situation in plan"
        },
        
      ];



/* "Springsemester 2025
6th semester at Beer & Merz
Co-author Oscar Zünd
created with ArchiCAD, Cinema 4D, Photoshop"*/


    const title = "Connect Casino";
    const subtitle = "Renovation of the Stadtcasino Basel";
    const description = "The Stadtcasino Basel is a five-story commercial building that currently houses two different restaurants, a Sprüngli, and a tourist office. It originally served as a music and cultural centre, which continues to exist today in the adjacent Stadtcasino. Its former use is still evident, especially on the hall floor: The hall itself has largely retained its aesthetic appeal, but has been heavily partitioned off and is no longer accessible to the public. The front building is prominently located on Barfüsserplatz, but has not yet established a clear relationship with it.";
    const secondDescription = "As part of the planned renovation, the front building will be given a new spatial, functional, and urban identity. In doing so, emphasis will be placed on treating the historic structure with respect, without neglecting the requirements of contemporary use. The historic grand ballroom is at the center of the project and is considered worthy of preservation. It will be restored to its original condition and returned to its full size. This will once again make it the heart of the building and, in combination with the other rooms, provide space for a wide variety of events.";
    const thirdDescription = "The focus of the project is the new extension on the north facade. This serves several purposes: the newly created space will enable the planned use, improve the accessibility of the building from Barfüsserplatz, strengthen the relationship with the music hall of the adjacent Stadtcasino, the Barfüsserkirche church, and the square, and act as a new representative facade for the building."
    const map = "./Semester_6/KarteBasel.webp";
    const semester = "Springsemester 2025";
    const professosr = "6th semester at Beer & Merz";
    const tools = "created with ArchiCAD, Cinema 4D, Photoshop";
    const coAuthor = "Co-author Oscar Zünd";

    const cards = [
      {
        id: 1,
        content: <p>Urban development model with focus on the front building of the Stadtcasino basel.</p>,
        className: "h-40 bg-blue-500",
        thumbnail: "./Semester_6/Umgebung.webp",
      },
      {
        id: 2,
        content: <p>The concept sketch illustrates the new entrances to the Stadtcasino, with the main access point on the front façade and a series of additional entrances along the north façade. The ground-floor arcade extends around the building to connect seamlessly with the north side.</p>,
        className: "h-40 bg-blue-500",
        thumbnail: "./Semester_6/Konzeptskizze.webp",
      },
      {
        id: 3,
        content: <p>The net Floor Area is divided into Circulation Area (yellow), service area (blue), main usable area (red), secondary usable area (orange) and external usable area (rose). Highlighted are the vertical connections throughout the building via stairs and elevators.</p>,
        className: "h-40 bg-red-500",
        thumbnail: "./Semester_6/Nettogeschossfläche.webp",
      },
      {
        id: 4,
        content: <p>The basement continues to serve as storage space for the businesses, with the only intervention being the addition of reinforcement columns in the northern section to support the new extension.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/Untergeschoss.webp",
      },
      {
        id: 5,
        content: <p>The ground floor is reorganized as a central point of arrival, accessible from all three main façades. At its heart are a cloakroom and reception. Both Sprüngli and Basel Tourism remain in their existing size, with the latter benefiting from a stronger connection to the building's centre.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/Erdgeschoss.webp",
      },
      {
        id: 6,
        content: <p>On the Mezzanine, a new restaurant with a bar is introduced, opening primarily towards the Barfüsserplatz. The left hand side provides space for seminar rooms.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/Entresol.webp",
      },
      {
        id: 7,
        content: <p>The hall floor regains the large main hall and is complemented by a new foyer in the extension. A backstage area is implemented, connectng to the stage rooms on the upper floor.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/Saalgeschoss.webp",
      },
      {
        id: 8,
        content: <p>The historic hall had visual connections to the Barfüsserplatz. Over the years, its three original opening were all closed leading to a loss of connection. In the project these three doorways are being reopened which once again strengthens the relationship between hall and square. </p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/Modellbild1.webp",
      },
      {
        id: 9,
        content: <p>The foyer is a bright room with skylights and chandeliers based on the historic ones in the hall. The salmon coloured steel imitates the plaster of the façade. The original windows are modified to become doorways while keeping the stone aesthetic. The materialtiy of the floor stretches into the building allowing both area, circulation and foyer to become one.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/Innenrender.webp",
      },
      {
        id: 10,
        content: <p>The upper mezzanine level houses the stage rooms with some foldable doors to section the space more efficiently.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/Zwischengeschoss.webp",
      },
      {
        id: 11,
        content: <p>On the top floor, the office spaces and technical rooms are bing expanded. One elevator now reaches to the top, making all floors wheelchair excessible.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/Dachgeschoss.webp",
      },
      {
        id: 12,
        content: <p>The broader urban integration is shown in the cut section.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/Querschnitt.webp",
      },
      {
        id: 13,
        content: <p>The extension is made up by the arcade on the entrance level and a window façade on the upper levels. It is designed to be self-supporting which is why additional columns are added in the basement. Steel columns pick up the symmetry of the façade and translate it into a simplistic and abstract version. Vertical louvers function as sunprotectors from early morning and evening sunrays. Most or the original Windows on the Catering and Foyer level are turned into doorways while keeping the stone frame.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/Axo.webp",
      },
      {
        id: 14,
        content: <p>The original railing is hihgtened, since it no longer meets SIA requirements. This is done for all railings on the balcony.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/1OGAufbau.webp",
      },
      {
        id: 15,
        content: <p>Connection between ground floor and upper floor façade.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/Fassadenaufbau.webp",
      },
      {
        id: 16,
        content: <p>The design of the roof is taken over from the existing roof to create a seamless appearance.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/Dachaufbau.webp",
      },
      {
        id: 17,
        content: <p>The extension in a rendering with view from the Barfüsserplatz.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_6/Aussenrender.webp",
      },
      
    ];
    
  return (
    <>
    <div className="pb-25 flex items-center justify-center bg-[#e7e5e4]">
        <Navbar />
    </div>
    
      <ImageCarousel images={carouselImages} title={title} />
      <ProjectDesciption subtitle={subtitle} description={description} secondDescription={secondDescription} thirdDescription={thirdDescription} map={map} semester={semester} professor={professosr} tools={tools} coAuthor={coAuthor}/>
      <ProjectCard cards={cards}/>
      <Footer />
    </>
  );
};

export default Project1;

